export default __webpack_public_path__ + "static/media/paradox-pub.c7e8d5a3.png";